module.exports = __webpack_public_path__ + "img/kolor-11.74d960d5.png";